export class ObjectUtil {
    static isEmpty(obj) {
        return Object.keys(obj).length === 0 && obj.constructor === Object;
    }
    static isNull(obj) {
        return obj === null || obj === undefined;
    }
}
